import { Component } from '@angular/core';

@Component({
  selector: 'app-map',
  imports: [],
  template: `<svg
  width="24"
  height="24"
  viewBox="0 0 18 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_482_4926)">
    <path
      d="M8.81393 18.2607C8.67523 18.2621 8.53971 18.2191 8.42714 18.1381C8.14412 17.9588 1.50262 13.4966 1.50262 8.07205C1.50262 6.13297 2.27292 4.27331 3.64406 2.90217C5.01519 1.53104 6.87485 0.760742 8.81393 0.760742C10.753 0.760742 12.6127 1.53104 13.9838 2.90217C15.3549 4.27331 16.1252 6.13297 16.1252 8.07205C16.1252 13.4966 9.52148 17.9588 9.20072 18.1381C9.08815 18.2191 8.95264 18.2621 8.81393 18.2607V18.2607ZM8.81393 2.223C7.25679 2.21799 5.76129 2.83111 4.65581 3.92775C3.55032 5.02439 2.92521 6.51492 2.91772 8.07205C2.91772 12.0437 7.43658 15.6758 8.81393 16.6852C10.1913 15.6758 14.7101 12.0437 14.7101 8.07205C14.7027 6.51492 14.0775 5.02439 12.9721 3.92775C11.8666 2.83111 10.3711 2.21799 8.81393 2.223V2.223Z"
      fill="white"
    />
    <path
      d="M8.81394 10.2414C8.30083 10.2414 7.79924 10.0892 7.37261 9.80418C6.94597 9.51911 6.61345 9.11393 6.41709 8.63988C6.22073 8.16583 6.16935 7.64419 6.26945 7.14094C6.36956 6.63769 6.61664 6.17542 6.97947 5.8126C7.34229 5.44977 7.80456 5.20269 8.30781 5.10258C8.81106 5.00248 9.3327 5.05386 9.80675 5.25022C10.2808 5.44658 10.686 5.7791 10.9711 6.20574C11.2561 6.63237 11.4083 7.13396 11.4083 7.64707C11.4083 8.33513 11.1349 8.99501 10.6484 9.48154C10.1619 9.96807 9.502 10.2414 8.81394 10.2414ZM8.81394 6.46783C8.58071 6.46783 8.35271 6.53699 8.15879 6.66657C7.96486 6.79614 7.81372 6.98031 7.72446 7.19579C7.63521 7.41127 7.61185 7.64838 7.65736 7.87713C7.70286 8.10588 7.81517 8.316 7.98009 8.48092C8.14501 8.64584 8.35513 8.75815 8.58388 8.80365C8.81263 8.84916 9.04974 8.8258 9.26522 8.73655C9.4807 8.64729 9.66487 8.49615 9.79445 8.30222C9.92402 8.1083 9.99318 7.8803 9.99318 7.64707C9.99318 7.33432 9.86894 7.03437 9.64779 6.81322C9.42664 6.59207 9.1267 6.46783 8.81394 6.46783V6.46783Z"
      fill="white"
    />
  </g>
  <defs>
    <clipPath id="clip0_482_4926">
      <rect
        width="17.5"
        height="17.5"
        fill="white"
        transform="translate(0.0639648 0.760742)"
      />
    </clipPath>
  </defs>
</svg>
`
})
export class MapComponent {

}
